import { Component, Prop } from "@stencil/core";
import { getIconRegistry } from "../registry";

@Component({
    tag: "ux-icon-set",
    shadow: false
})
export class IconSet {
    /** Path where the asset files are served from */
    @Prop() readonly assetsPath!: string;
    /** Namespace of the icon-set */
    @Prop() readonly ns!: string;
    /** File extension used to resolve the asset url */
    @Prop() readonly fileExtension: string = ".svg";

    componentWillLoad() {
        getIconRegistry().registerIconSet(this);
    }
}
